/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updateyoureventinformation3Inputs */

const en_updateyoureventinformation3 = /** @type {(inputs: Updateyoureventinformation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update your event information`)
};

const de_updateyoureventinformation3 = /** @type {(inputs: Updateyoureventinformation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändere die Infos zu deinem Event`)
};

/**
* | output |
* | --- |
* | "Update your event information" |
*
* @param {Updateyoureventinformation3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const updateyoureventinformation3 = /** @type {((inputs?: Updateyoureventinformation3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updateyoureventinformation3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_updateyoureventinformation3(inputs)
	return de_updateyoureventinformation3(inputs)
});
export { updateyoureventinformation3 as "updateYourEventInformation" }